<div class="password-bloc login-bloc">

  <div class="row" (click)="toggleCollapse()">
    <div class="logo">
      <div class="password-like-field">
        <span class="hidden-char">*</span>
        <span class="hidden-char">*</span>
        <span class="hidden-char">*</span>
      </div>
    </div>
    <div class="content">
      <h2>Login avec mot de passe</h2>
    </div>
  </div>

  <div class="details" [@collapsed]="collapsed$ | async" *ngIf="(collapsed$ | async)!=null">

    <p *ngIf="recoverWanted && !recoverCompleted">
      Entrez votre adresse email, et cliquez sur le lien qui vous sera envoyé
    </p>

    <form #theForm (ngSubmit)="onFormSubmit()" *ngIf="waitingForMail || waitingForPassword">
      <div class="col">


        <div class="row" *ngIf="waitingForMail">
          <input type="email" pInputText
                 name="contactMail"
                 placeholder="Adresse email"
                 required
                 [disabled]="validating$ | async"
                 [(ngModel)]="contactMail">

        </div>


        <input type="submit" hidden>
        <div class="row" *ngIf="waitingForPassword">
          <input type="password" pInputText
                 name="contactPassword"
                 placeholder="Mot de passe"
                 required
                 [disabled]="validating$ | async"
                 [(ngModel)]="contactPassword">

        </div>
      </div>

      <div class="col actions">
        <ng-template [ngIf]="recoverWanted">
          <a class="lifeislife-button-link"
             title="Envoyer" i18n-title
             [class.disabled]="theForm.invalid || (recovering$ | async)"
             (click)="sendRecoverMail();">
            <!--        <i class="fa fa-envelope-o"></i>-->
            <span>Envoyer</span>
          </a>
        </ng-template>
        <ng-template [ngIf]="!recoverWanted">
          <a class="lifeislife-button-link"
             title="Envoyer l'email" i18n-title
             [class.disabled]="theForm.invalid || (validating$ | async)"
             (click)="onPasswordSubmit();">
            <!--        <i class="fa fa-envelope-o"></i>-->
            <span>Se connecter</span>
          </a>
        </ng-template>

      </div>

    </form>

    <p *ngIf="!recoverWanted">
      <a class="forget-password-link"
         title="Réinitialiser mon mot de passe" i18n-title
         (click)="onRecoverPasswordClick()">
        Réinitialiser mon mot de passe
      </a>
    </p>


    <span class="validating-message" *ngIf="validating$ | async">
      Vérification...
    </span>
    <span class="validating-message" *ngIf="recovering$ | async">
      Vérification...
    </span>

    <div *ngIf="recoverWanted && recoverCompleted">
      <div *ngIf="recoverSucceeded">
        <p>
          Un lien a été envoyé à {{ contactMail }}. Utilisez-le pour vous connecter et choisir un nouveau
          mot de passe.
        </p>
      </div>
      <p *ngIf="!recoverSucceeded">
        Impossible de reinitialiser votre mot de passe.
      </p>
      <p *ngIf="recoverError" class="error">
        Message d'erreur: {{ recoverError }}
      </p>
    </div>


    <div *ngIf="!recoverWanted && !(validating$ | async) && loginCompleted">

      <div *ngIf="loginError">
        <p>
          Impossible de se connecter.
        </p>
        <p *ngIf="loginError" class="error">
          Message d'erreur: {{ loginError }}
        </p>

      </div>

    </div>


    <div class="links">
      <a class="rembered-password-link" *ngIf="recoverWanted"
         title="Retour" i18n-title
         (click)="onRememberedPasswordClick()">
        Retour
      </a>
    </div>


  </div>


</div>
